module.exports = __webpack_public_path__ + "img/trash.10239498.svg";